// components/InvoiceBulkActionBar.jsx
import React from "react";
import { Box, Flex, HStack, Text, Button, Spinner } from "@chakra-ui/react";
import { FiDownload } from "react-icons/fi";

const HOVER_SCALE = { transform: "scale(1)" };

const InvoiceBulkActionBar = ({
  selectedCount,
  onClear,
  onDownload,
  isDownloading,
}) => {
  if (!selectedCount) return null;

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      bg="gray.900"
      color="white"
      px={4}
      py={3}
      boxShadow="0 -4px 16px rgba(0,0,0,0.3)"
      zIndex={30}
    >
      <Flex justify="space-between" align="center" maxW="1200px" mx="auto">
        <Text fontWeight="medium">
          {selectedCount} invoice
          {selectedCount > 1 ? "s" : ""} selected
        </Text>
        <HStack spacing={3}>
          <Button
            variant="outline"
            size="sm"
            onClick={onClear}
            _hover={HOVER_SCALE}
            color="white"
            borderColor="white"
          >
            Clear
          </Button>
          <Button
            size="sm"
            colorScheme="teal"
            leftIcon={!isDownloading ? <FiDownload /> : undefined}
            onClick={onDownload}
            isDisabled={isDownloading || selectedCount === 0}
            _hover={HOVER_SCALE}
          >
            {isDownloading ? <Spinner size="sm" mr={2} /> : null}
            {isDownloading ? "Preparing ZIP..." : "Download Invoices (ZIP)"}
          </Button>
        </HStack>
      </Flex>
    </Box>
  );
};

export default InvoiceBulkActionBar;
